import { useLang } from "@/context/LangContext";
import { FadeUp } from "@/components/Reveal";
import { clinicianQuote } from "@/data/products";

export default function TrustStrip() {
  const { t } = useLang();
  const items = t("trust");
  return (
    <section data-testid="trust-strip" className="border-y border-ink/10 bg-white">
      <FadeUp amount={0.6}>
        <ul className="mx-auto grid max-w-[1400px] grid-cols-2 md:grid-cols-4">
          {items.map((item, i) => (
            <li
              key={item}
              data-testid={`trust-item-${i}`}
              className={`flex items-center justify-center px-4 py-6 text-center text-[11px] font-medium uppercase tracking-[0.22em] text-ink/60 ${
                i > 0 ? "border-l border-ink/10" : ""
              } ${i === 2 ? "max-md:border-l-0 max-md:border-t max-md:border-ink/10" : ""} ${
                i === 3 ? "max-md:border-t max-md:border-ink/10" : ""
              }`}
            >
              {item}
            </li>
          ))}
        </ul>
      </FadeUp>

      {clinicianQuote && (
        <FadeUp amount={0.4}>
          <figure data-testid="clinician-quote" className="border-t border-ink/10 px-5 py-16 text-center md:py-20">
            <blockquote className="mx-auto max-w-3xl font-serif text-2xl leading-[1.35] tracking-tight text-ink md:text-4xl">
              “{clinicianQuote.text}”
            </blockquote>
            <figcaption className="mt-8 text-[11px] font-medium uppercase tracking-[0.3em] text-ink/50">
              {clinicianQuote.name} — {clinicianQuote.role}
            </figcaption>
          </figure>
        </FadeUp>
      )}
    </section>
  );
}
